import Vue from 'vue'
import VueRouter from 'vue-router'
import routers from './routers'
import App from './App.vue'
import axios from 'axios'


import { Dialog, Button, Form, FormItem, Input, Upload, Message } from 'element-ui'
Vue.component(Dialog.name, Dialog);
Vue.component(Button.name, Button);
Vue.component(Form.name, Form);
Vue.component(FormItem.name, FormItem);
Vue.use(Input)
Vue.use(Upload)
Message.install = function (Vue) {
    Vue.prototype.$message = Message
}
Vue.use(Message)
Vue.use(VueRouter)

Vue.prototype.$axios = axios;

const router = new VueRouter({
    mode: 'history',
    routes: routers
})

Vue.config.productionTip = false

new Vue({
    router,
    render: h => h(App)
}).$mount('#app')